"use strict";

var ubian = ubian || {};

ubian.cookieConsent = {};
ubian.cookieConsent.AllowedAll = "---technical.1_analytics.1";
ubian.cookieConsent.AllowedTechnicalOnly = "---technical.1_analytics.0";
ubian.cookieConsent.cookieName = 'ubian_cookie_consent';
ubian.cookieConsent.originalUrl = window.location.toString();
ubian.cookieConsent.init = function () {
  if (!Cookies.get(ubian.cookieConsent.cookieName) && !$("body").hasClass("appmode") && $("#payIFrame").length == 0 && (typeof window.ubian_disable_classic_cookie_consent == 'undefined')) {
    ubian.cookieConsent.show();
  }
  if ($(".js-cookie-toggle").length) {
    ubian.cookieConsent.initToggles();
  }
};

ubian.cookieConsent.show = function () {

  if (window.location.href.includes("/cookies")) {
    return;
  }
  var ok_Cb = function () {
    $.post(ubian.routes['static-update-cookie-consent'], { 'cookiesSettings': ubian.cookieConsent.AllowedAll })
      .always(function () {
        if (ubian.cookieConsent.originalUrl && ubian.cookieConsent.originalUrl.indexOf("#") != -1) {
          window.location = ubian.cookieConsent.originalUrl;

        }
        window.location.reload();
      });
  };
  var cancel_Cb = function () {
    window.location.href = "/cookies?id=cookies-settings";
  }
  ubian.utils.confirmDialog(ubian.translate("CookieConsent.Text"), ubian.translate("CookieConsent.Title"), ubian.translate("CookieConsent.Agree"), ok_Cb, ubian.translate("CookieConsent.Options"), cancel_Cb, null, null, true);
  /*var template =
    '<div class="cookie-consent js-cookie-consent"><span>' +
    ubian.translate("CookieConsent.Text") +
    '</span><button class="btn pull-right js-cookies-ok">' +
    ubian.translate("CookieConsent.Agree") +
    "</button></div>";
  $("body").append(template);
  $("body").on("click", ".js-cookies-ok", function () {
    $.post(ubian.routes['static-update-cookie-consent'], {'cookiesSettings': ubian.cookieConsent.AllowedAll});
    $(".js-cookie-consent").fadeOut();
  });*/
};

ubian.cookieConsent.initToggles = function () {
  var cookieStatus = ubian.cookieConsent.getValue();
  var enabledAll = ubian.cookieConsent.isOldAllowed();
  //var isEmpty = cookieStatus == "";
  var cookies = ubian.cookieConsent.getCookieTypesSettings();
  // set status of cookie checkboxes
  $(".js-cookie-toggle input").each(function () {
    var val = $(this).attr("value");
    if (enabledAll || cookies.indexOf(val + ".1") !== -1) {
      $(this).prop("checked", true);
    }
  });
  // update cookies preferences
  /*$(".js-cookie-toggle input").change(function () {
    var val = $(this).attr("value");
    var isAllowed = $(this).is(":checked");
    var newVal = val + "." + (isAllowed ? "1" : "0");
    var oldVal = val + "." + (isAllowed ? "0" : "1");
    var current =
      ubian.cookieConsent.getValue() || ubian.cookieConsent.AllowedAll;
    if (ubian.cookieConsent.isOldAllowed) {
      current = ubian.cookieConsent.AllowedAll;
    }
    var newCookies = current.replace(oldVal, newVal);
    $.post(ubian.routes['static-update-cookie-consent'], {'cookiesSettings': newCookies});
  });*/
};

ubian.cookieConsent.isOldAllowed = function () {
  var cookieStatus = Cookies.get(ubian.cookieConsent.cookieName) || "";
  var enabledAll = cookieStatus && cookieStatus.indexOf("---") === -1;
  return enabledAll;
};

ubian.cookieConsent.getValue = function () {
  return Cookies.get(ubian.cookieConsent.cookieName) || "";
};

ubian.cookieConsent.getCookieTypesSettings = function () {
  var cookieStatus = ubian.cookieConsent.getValue();
  if (cookieStatus.indexOf("---") === 0) {
    cookieStatus = cookieStatus.replace("---", "");
    return cookieStatus.split("_");
  }
  return [];
};

function changeCookie(allowAll) {
  if (allowAll) {
    $.post(ubian.routes['static-update-cookie-consent'], { 'cookiesSettings': ubian.cookieConsent.AllowedAll })
      .done(function () {
        //ubian.utils.alert(ubian.translate("CookieConsent.CookiesChanged"));
        //document.getElementById("analytic-cookies-setting").checked = true;
        window.history.back();
      })
      .fail(function () {
        ubian.utils.alert(ubian.translate("CookieConsent.CookiesChanged.Error"));
      });
  }
  else {
    $.post(ubian.routes['static-update-cookie-consent'], { 'cookiesSettings': ubian.cookieConsent.AllowedTechnicalOnly })
      .done(function () {
        //ubian.utils.alert(ubian.translate("CookieConsent.CookiesChanged"));
        window.history.back();
      })
      .fail(function () {
        ubian.utils.alert(ubian.translate("CookieConsent.CookiesChanged.Error"));
      });
  }
}


$(function () {
  $('#accept-all-cookies').click(function () {
    changeCookie(true);
  });
  $('#save-cookies-settings').click(function () {
    changeCookie($("#analytic-cookies-setting").is(":checked"));
  });

  if (window.location.href.includes('/cookies?id=cookies-settings')) {
    $("#fullpage").scrollTop($("#cookies-settings").offset().top);
  }
});
